export default "__VITE_ASSET__tslmwCkX__"